import { ReactNode } from 'react'
import '@fontsource/poppins'
import '@fontsource/poppins/500.css'

// Material-UI
import { createTheme, ThemeProvider, ThemeOptions } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import StyledEngineProvider from '@mui/material/StyledEngineProvider'

// Project imports
import customShadows from './shadows'
import Palette from './palette'
import Typography from './typography'
import createStyles from './componentStyles'
import { borderRadius, outlinedFilled } from '../store/constant'

interface ThemeCustomizationProps {
  children: ReactNode
}

export default function ThemeCustomization({
  children,
}: ThemeCustomizationProps) {
  const fontFamily = '"Poppins", "Arial", sans-serif'
  const theme = Palette()
  const themeTypography = Typography(theme, fontFamily)

  const themeOptions: ThemeOptions = {
    palette: theme.palette,
    typography: themeTypography,
    shadows: customShadows,
  }

  const themes = createTheme(themeOptions)

  themes.components = createStyles({
    theme: themes,
    borderRadius,
    outlinedFilled,
  })

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
